module.exports = __webpack_public_path__ + "static/img/img(30).046f3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(30).png
// module id = Jw//
// module chunks = 1